import ouiBase from '@goldwasserexchange/oui';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useCallback } from 'react';
import { useAccountOrderFieldApiByOpbFordId, useAccountOrderFieldTransfomApiByOpbFordId } from '../api';
import { AccountsOrder } from '../../type';
import { MessageDescriptor } from '@lingui/core';

export enum McOpbLimite {
  NULL = 5300,
  CARE = 5301,
  LIMITE = 5302,
  LAST = 5303,
  OPEN = 5304,
  MARKET = 5305,
  STOP_LIMIT = 5306,
  MUSTBEFILLED = 5307,
  ALLORNONE = 5308,
  STOP_LOSS = 5309,
}

export const useAccountOrderOpbFordMcOpbLimite = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountOrderFieldApiByOpbFordId({
    opbFordDId,
    field: 'OPB_FORD.MC_OPB_LIMITE',
  });
  return response;
};

export const mcOpbLimiteOrderType = {
  [McOpbLimite.MARKET]: 'MARKET',
  [McOpbLimite.LIMITE]: 'LIMIT',
} as const;

const transformOrderTypeFunction = (limiteId: AccountsOrder['OPB_FORD.MC_OPB_LIMITE'] | undefined) => {
  if (limiteId == null || (limiteId !== 5302 && limiteId !== 5305)) {
    return undefined;
  }
  const limitType = mcOpbLimiteOrderType[limiteId];
  return limitType;
};

export const useAccountOrderOpbFordMcOpbLimiteOrderType = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountOrderFieldTransfomApiByOpbFordId({
    opbFordDId,
    field: 'OPB_FORD.MC_OPB_LIMITE',
    transformFunction: transformOrderTypeFunction,
  });
  return response;
};

export const mcOpbLimiteMessageDescriptions = {
  [McOpbLimite.MARKET]: msg`Marché`,
  [McOpbLimite.LIMITE]: msg`Limite`,
  [McOpbLimite.STOP_LIMIT]: msg`Stop Limit`,
  [McOpbLimite.STOP_LOSS]: msg`Stop Loss`,
};

export const translateMcOpbLimite = (_: (descriptor: MessageDescriptor) => string, limiteId: AccountsOrder['OPB_FORD.MC_OPB_LIMITE'] | undefined) => {
  if (limiteId == null) {
    return undefined;
  }
  const message = mcOpbLimiteMessageDescriptions[limiteId];
  if (message == null) {
    return undefined;
  }
  return _(message);
};

const useTranslateMcOpbLimite = () => {
  const {
    _,
  } = useLingui();
  const translate = useCallback(
    (limiteId: AccountsOrder['OPB_FORD.MC_OPB_LIMITE'] | undefined) => translateMcOpbLimite(_, limiteId),
    [_],
  );
  return translate;
};

export const useAccountOrderOpbFordMcOpbLimiteText = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const transformTextFunction = useTranslateMcOpbLimite();
  const response = useAccountOrderFieldTransfomApiByOpbFordId({
    opbFordDId,
    field: 'OPB_FORD.MC_OPB_LIMITE',
    transformFunction: transformTextFunction,
  });
  return response;
};
